import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { BrandLogo } from '@/shared/components/BrandLogo';
import { AuthPageFooter } from '@/features/auth/components/AuthPageFooter';
import { TravelerProfileGate } from '@/features/auth/components/TravelerProfileGate';

export function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'clip',
        bgcolor: 'background.default',
      }}
    >
      <TravelerProfileGate />
      <Box
        sx={{
          flex: 1,
          minHeight: '58dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: { xs: 3, sm: 4 },
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 460,
            bgcolor: 'background.paper',
            borderRadius: 'calc(var(--radius-xl) + 4px)',
            p: { xs: 3, sm: 4 },
            border: '1px solid',
            borderColor: 'divider',
            backgroundImage:
              'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(249,247,242,0.98) 100%)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 2.5, sm: 3.5 } }}>
            <BrandLogo size="md" surface="light" />
          </Box>
          <Outlet />
        </Box>
      </Box>

      <AuthPageFooter />
    </Box>
  );
}
